import {
    ableProps,
    ablePropsInit,
    events as baseEvents,
} from '../component-base/props';

export const props = () => [
    ...ableProps,
    {
        key: 'html',
        label: '元素HTML',
        type: 'html',
        props: {
            type: 'textarea', // TODO 以后考虑搞个富文本编辑器？
            rows: 5,
        },
    },
    {
        key: 'i18nPattern',
        label: '国际化标志',
        type: 'string',
        props: {
            placeholder: '请输入正则表达式',
        },
    },
    {
        key: 'attrs',
        label: '元素属性',
        type: 'object',
    },
    {
        key: 'removeWrapStyle',
        label: '是否移除外部样式',
        type: 'boolean',
    },
    {
        key: 'groupTitle',
        label: '标题文字',
        type: 'string',
    },
];

export const init = () => ({
    ...ablePropsInit,
    html: '',
    i18nPattern: '',
    attrs: {},
    removeWrapStyle: false,
});

export const name = 'HTML内容';

export const component = 'mobile-general-form-html-content';

export const events = [
    ...baseEvents,
];
